<!--suppress ALL -->
<template>
  <div>
    <div class="page case-detail__content">
      <div class="padding15 bg-content m-b-24">
        <div class="bg-content padding15">
          <el-form size="small" label-width="100px" ref="searchRef">
            <el-row :gutter="12">
              <el-col :span="8">
                <el-form-item label="创建时间">
                  <el-date-picker v-model="searchReq.startTime" style="width: 100%;" type="datetime" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期时间"/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="至">
                  <el-date-picker v-model="searchReq.endTime" style="width: 100%;" type="datetime" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期时间"/>
                </el-form-item>
              </el-col>
              <!-- 按钮操作 -->
              <div class="padding15-tb text right">
                <el-button type="primary" size="small" plain @click="searchReq.page = 1; getList();"><i class="fa fa-search"></i> 搜索</el-button>
                <el-button size="small" @click="reset">重置</el-button>
              </div>
            </el-row>
          </el-form>
        </div>
        <div class="padding15 bg-content">
          <el-button
            type="primary"
            icon="el-icon-plus"
            size="mini"
            @click="handleAdd"
          >新增</el-button>
          <el-button
            type="danger"
            icon="el-icon-delete"
            size="mini"
            :disabled="multiple"
            @click="handleDelByIds"
          >删除</el-button>
          <br/><br/>
          <el-table size="small" :data="conditionList.list" v-loading="loading" @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="55" align="center" />
            <el-table-column fixed property="routeConfName"  label="路由名称"  align="center"/>
            <el-table-column fixed label="路由类型" align="center" min-width="100">
              <template slot-scope="scope">
                <span v-if="scope.row.type === 1">对话场景</span>
              </template>
            </el-table-column>
            <el-table-column fixed property="groupName"  label="所属策略"  align="center"/>
            <el-table-column fixed label="目标场景" align="center" :show-overflow-tooltip="true">
              <template slot-scope="scope">
                <router-link  style="text-decoration: none;" :to="'/main/collection/condition/scene/detail/'+ scope.row.companyId +'/' + scope.row.id" class="link-type">
                  <span>{{ scope.row.routeBusinessName }}</span>
                </router-link>
              </template>
            </el-table-column>
            <el-table-column fixed property="createTime"  label="创建时间"  align="center"/>
            <el-table-column fixed label="操作" align="center">
              <template slot-scope="scope">
                <el-button type="text" size="small" @click="updateButton(scope.row)"><i class="el-icon-edit-outline"></i>&nbsp;编辑</el-button>
                <el-button type="text" icon="el-icon-delete" size="mini" @click="handleDelete(scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="text center margin15-tb">
            <el-pagination
              background
              layout="prev, pager, next, sizes, total"
              :total="conditionList.totalRecords"
              :page-size="searchReq.limit"
              :current-page="searchReq.page"
              @current-change="currentChange"
              @size-change="sizeChange">
            </el-pagination>
          </div>
        </div>
        <!--    编辑    -->
        <el-dialog :title="title" :visible.sync="open" width="500px" append-to-body>
          <el-form ref="form" :model="form" label-width="80px">
            <el-form-item label="目标场景" prop="routeBusinessId">
              <el-select v-model="form.routeBusinessId" filterable clearable placeholder="请选择" style="width: 80%;">
                <el-option
                  v-for="item in sceneOption"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                  <template>
                    <el-tooltip placement="top" effect="light">
                      <div slot="content" v-html="item.contentShow === undefined || item.contentShow === null ? item.content : item.contentShow"></div>
                      <span>{{item.name}}</span>
                    </el-tooltip>
                  </template>
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="submitForm">确认</el-button>
            <el-button @click="cancel">取消</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      loading: true,
      searchReq: {
        companyId: null,
        confName: null,
        status: null,
        type: 1,
        startTime: null,
        endTime: null,
        page: 1,
        limit: 10,
        order: 'create_time',
        sort: 'desc'
      },
      conditionList: { 'totalRecords': 0, list: [] },
      // 表单参数
      form: {
        routeGroupId: null,
        routeBusinessId: null
      },
      // 弹出层标题
      title: '',
      // 是否显示弹出层
      open: false,
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      // 上层的条件路由基本信息id
      routeConfId: null,
      companyId: null,
      groupId: null,
      sceneReq: {
        companyId: null,
        groupId: null,
        type: 'svoice'
      },
      sceneOption: []
    };
  },
  mounted() {
    this.routeConfId = this.$route.params && this.$route.params.routeConfId;
    this.getList();
    // 查询对话场景
    this.companyId = this.$route.params && this.$route.params.companyId;
    this.groupId = this.$route.params && this.$route.params.groupId;
    this.sceneReq.companyId = this.companyId;
    this.sceneReq.groupId = this.groupId;
    this.getSceneOptionList(this.sceneReq);
  },
  methods: {
    getList() {
      this.loading = true;
      this.searchReq.routeConfId = this.routeConfId;
      this.$ajax({
        method: 'get',
        url: '/commonRelation/list',
        params: this.searchReq
      }).then((res) => {
        this.conditionList.list = res.data.list;
        this.conditionList.totalRecords = res.data.totalRecords;
        this.loading = false;
      });
    },
    // 多选框选中数据
    handleSelectionChange(selection) {
      this.ids = selection.map(item => item.id);
      this.single = selection.length !== 1;
      this.multiple = !selection.length;
    },
    updateButton(row) {
      this.form.routeGroupId = row.routeGroupId;
      this.form.routeBusinessId = row.routeBusinessId;
      this.resetForm();
      this.form.id = row.id;
    },
    handleAdd() {
      this.form.routeGroupId = null;
      this.form.routeBusinessId = null;
      this.resetForm();
    },
    resetForm() {
      this.form.id = null;
      this.form.routeConfId = this.routeConfId;
      this.open = true;
    },
    // 重置
    reset() {
      this.searchReq.startTime = null;
      this.searchReq.endTime = null;
    },
    currentChange(page) {
      this.searchReq.page = page;
      this.getList();
    },
    // 显示条数
    sizeChange(num) {
      this.searchReq.limit = num;
      this.getList();
    },
    submitForm() {
      if (this.form.id) {
        this.$ajax({
          method: 'post',
          url: '/commonRelation/update',
          data: this.form
        }).then((res) => {
          if (res.code === 200) {
            this.$message({
              type: 'success',
              message: '成功!'
            });
            this.open = false;
            this.getList();
          } else {
            this.$message({
              type: 'error',
              message: '失败!'
            });
          }
        });
      } else {
        this.$ajax({
          method: 'post',
          url: '/commonRelation/save',
          data: this.form
        }).then((res) => {
          if (res.code === 200) {
            this.$message({
              type: 'success',
              message: '成功!'
            });
            this.open = false;
            this.getList();
          } else {
            this.$message({
              type: 'error',
              message: '失败!'
            });
          }
        });
      }
    },
    cancel() {
      this.open = false;
      this.reset();
    },
    handleDelByIds() {
      this.$confirm('是否确认删除 ?', '警告', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning'
      }).then(() => {
        this.$ajax({
          method: 'delete',
          url: '/commonRelation/del',
          data: this.ids
        }).then((res) => {
          if (res.code === 200) {
            this.$message({
              type: 'success',
              message: '成功!'
            });
          } else {
            this.$message({
              type: 'error',
              message: '失败!'
            });
          }
        }).finally(() => {
          this.getList();
        });
      });
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      this.$confirm(`是否确认删除目标场景：${row.routeBusinessName} ?`, '警告', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning'
      }).then(() => {
        this.$ajax({
          method: 'delete',
          url: `/commonRelation/del/${row.id}`
        }).then((res) => {
          if (res.code === 200) {
            this.$message({
              type: 'success',
              message: '成功!'
            });
          } else {
            this.$message({
              type: 'error',
              message: '失败!'
            });
          }
        }).finally(() => {
          this.getList();
        });
      });
    },
    // 对话场景列表
    getSceneOptionList(dataReq) {
      this.$ajax({
        url: '/scene/getSceneParam',
        method: 'POST',
        data: dataReq
      }).then((res) => {
        this.sceneOption = res.data;
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/page/main/collection/condition/scene/relation/index.vue